<script setup lang="ts">
import { CalendarDays, ChevronRight } from 'lucide-vue-next'
import TodayWidget from './TodayWidget.vue'

/** `toGrade` may be a string ("—") when no backlog source is wired yet. */
defineProps<{ lessons: number; dueIn: number; toGrade: number | string }>()
const emit = defineEmits<{ openSchedule: [] }>()
</script>

<template>
  <TodayWidget :icon="CalendarDays" icon-hue="teal" title="This week">
    <div class="week__stats">
      <div class="week__stat">
        <div class="week__num">{{ lessons }}</div>
        <div class="week__label">lessons</div>
      </div>
      <div class="week__stat">
        <div class="week__num">{{ dueIn }}</div>
        <div class="week__label">due in</div>
      </div>
      <div class="week__stat">
        <div class="week__num">{{ toGrade }}</div>
        <div class="week__label">to grade</div>
      </div>
    </div>
    <template #footer>
      <button type="button" class="week__open" @click="emit('openSchedule')">
        Open schedule <ChevronRight :size="13" />
      </button>
    </template>
  </TodayWidget>
</template>

<style scoped>
.week__stats {
  display: flex;
  gap: 8px;
  padding: 4px 0 12px;
}
.week__stat {
  flex: 1;
}
.week__num {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: var(--text-primary);
}
.week__label {
  font-size: 11.5px;
  color: var(--ink-500);
  margin-top: 1px;
}
.week__open {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-700);
}
</style>
